/** Floor is derived from suite units, not stored on suites. */

export const deriveSuiteFloorFromUnits = (units) => {
  if (!units?.length) {
    return null;
  }
  return Math.min(...units.map((unit) => unit.floor));
};

export const isSuiteFloorNone = (floor) => floor === null || floor === undefined || floor === '';

export const formatSuiteFloorDisplay = (floor) =>
  isSuiteFloorNone(floor) ? 'None' : floor;

export const formatSuiteFloorFromUnits = (units) =>
  formatSuiteFloorDisplay(deriveSuiteFloorFromUnits(units));
